<template>
  <p>
    <strong v-if="processor == 'stripe'">
      {{ $tt('credit_card_charge_on_click') }}
      <PriceSpan :price="total" />
    </strong>
    <strong v-else-if="processor == 'tbank'">
      {{ $tt('redirect_payment_on_click') }}
    </strong>
    <br>
    {{ $tt('order_email_after_payment') }}
    <br>
    <span v-html="$tt('contact_on_pay_issue')" />
  </p>
</template>

<script setup lang="ts">
import type { PaymentProcessor } from '~/types';

defineProps<{
  total: number;
  processor: PaymentProcessor;
}>();
</script>

<style scoped>
p {
  font-size: 14px;
  margin-bottom: 0;
  margin-top: var(--space-4);
}
</style>